export interface IAppendMessageRequest {
    id: string;
    append_message: number;
}
